import React from 'react';
import styled from 'styled-components';
import { RichText } from 'prismic-reactjs';

const Container = styled.div`
  background: #DEDEDE;
  padding: 46px 0;
  .flex {
    justify-content: space-between;
    align-items: flex-start;
    &.reverse {
      flex-direction: row-reverse;
      div .seal {
        right: inherit;
        left: -10px;
      }
    }
    @media (max-width: 540px) {
      flex-wrap: wrap;
    }
    div {
      width: 48%;
      height: 100%;
      position: relative;
      @media (max-width: 540px) {
        width: 100%;
        margin-top: 10px;
      }
    }
    .video {
      width: 100%;
      min-height: 400px;
      div,
      iframe {
        height: 100%;
        min-height: 400px;
        width: 100%;
      }
    }
  }
  img {
    width: 100%;
  }
  .image {
    .title {
      @media (min-width: 789px) {
        display: none;
      }
    }
  }
  .text {
    .title {
      @media (max-width: 789px) {
        display: none;
      }
    }
  }
  h1,
  h2 {
    font: italic bold 36px 'Times new roman';
    margin: 0 0 20px;
  }
  h3 {
    font: italic bold 26px 'Times new roman';
    margin: 0 0 15px;
  }
  ul {
    margin: 0;
    padding: 0;

    li {
      margin: 1em 0;
      list-style: none;
      
      &:before {
        content: '– ';
      }
    }
  }
  li,
  P {
    color: #616161;
    font-size: 14px;
    line-height: 24px;
  }
  a {
    cursor: pointer;
    max-width: 380px;
    width: 100%;
    background: #F1A857;
    display: flex;
    border-radius: 3px;
    border: 0;
    color: #fff;
    height: 60px;
    align-items: center;
    font-size: 16px;
    padding: 0;
    margin-top: 30px;
    text-decoration: none;
    @media (max-width: 1080px) {
      margin: 0 auto;
    }
    span {
      height: 100%;
      flex-grow: 1;
      border-right: 1px solid #D99440;
      display: flex;
      padding: 0 20px;
      align-items: center;
      justify-content: center;

      &.icon {
        max-width: 40px;
      }
    }
    i {
      width: 50px;
      background: url(/images/arrow-right.png) center no-repeat;
      height: 100%;
    }
  }
`

const Block = ({imagem, index, video, titulo, texto, link, download, texto_botao}) => {
  return (
    <Container id={ link }>
      <div className={ `wrapper flex ${(index + 1) % 2 === 0 ? 'reverse' : '' }` }>
        <div>
          {
            imagem.url && (
              <img  alt="" src={ imagem.url } />
            )
          }
          {
            video[0] && (
              <div className="video">
                { RichText.render(video) }
              </div>
            )
          }
        </div>
        <div>
          { RichText.render(titulo) }
          { RichText.render(texto) }
          { 
            (download && download.url) && (
              <a href={ download.url } target="_blank" rel="noopener noreferrer">
                <span className="text">
                  { texto_botao }
                </span>
                <span className="icon">
                  <i></i>
                </span>
              </a>
            )
          }
        </div>
      </div>
    </Container>
  )
}

export default Block;
